import { getRolesForServicesAPI } from "../apis/getRolesForServicesAPI";

// export const roleSelectorDeterminator = async (company_id) => {
//   // const userPermissions = await localforage.getItem("userPermissions");
//   // const userRole = await localforage.getItem("userRole");
//   const { roles = [], companyRoles = [] } = await getRolesForServicesAPI(
//     company_id
//   );
//   const roleNames = roles.map((role) => {
//     return role.name;
//   });
//   //  const visibleRoleNames = roleNames.slice(roleNames.indexOf(userRole));
//   const companyRoleNames = companyRoles.map((role) => {
//     return role.name;
//   });
//   // if (!userPermissions.includes("administrator_role")) {
//   //   const removedRoleIndex = roleNames.indexOf("Administrator");
//   //   roleNames.splice(removedRoleIndex, 1);
//   // }
//   return roleNames.concat(companyRoleNames);
// };

export const roleSelectorDeterminator = async (company_id) => {
  const { roles = [], companyRoles = [] } = await getRolesForServicesAPI(
    company_id
  );
  return roles.concat(companyRoles);
};
